/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import StickAPI from '@/api/StickAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';

export default {
	getStick: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam())
		});
		if (res && res.Data) {
			context.commit('stickInfo', res.Data);
		}
		return res;
	},
	getStickByOrg: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: StickAPI.getAPIUrlSubParam(`${payload.SubscriberId}/${payload.OrganizationId}`) + `/getstick`
		});
		return res;
	},
	saveStick: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/save`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('addStickItem', res.Data);
		}
		return res;
	},
	updateInvoiceStick: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/updateinv`,
				data: payload
			},
			true
		);
		return res;
	},
	deleteStick: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/delete/${payload}`
			},
			true
		);
		if (res && res.Data) {
			context.commit('removeStickItem', payload);
		}
		return res;
	},

	updateInfoSticks: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update-stick`,
				data: payload
			},
			true
		);
		if (res && res.Data) {
			return res;
		}
		return res;
	},

	removeAllStick: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/remove-sticks',
				data: payload
			},
			true
		);
		if (res && res.Data) {
			return res;
		}
	},

	/**
	 * Lấy danh sách AutomaticStick theo ID nhãn dán
	 * @param {Object} context - Context của Vuex
	 * @param {Object} payload - Dữ liệu truyền vào
	 * @param {String} payload.id - ID của nhãn dán cần lấy thông tin
	 * @returns {Promise} - Promise kết quả trả về từ API
	 */
	getAutomaticStick: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: StickAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/automatic-stick/${payload.id}`
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	}
};
